import type { ChartOption } from '@app-types/chart';
import type { ComparisonRatingBucket } from '@app-types/comparison';
import { CHART_AXIS_LABEL_STYLE, CHART_COLORS, CHART_FONT_FAMILY } from './chartConstants';

const formatRatingAxisLabel = (label: string): string =>
  label === 'やや強気' ? 'やや\n強気' : label === 'やや弱気' ? 'やや\n弱気' : label;

/**
 * Build ECharts option for the 5-bar rating distribution chart used in
 * ComparisonCard. Each bar has its own color from the bucket.
 * See kiro_comparison_tasks.md §8, Figma node 3226:19249.
 */
export function buildComparisonRatingOption(
  ratings: ComparisonRatingBucket[]
): ChartOption {
  return {
    grid: { left: 8, right: 8, top: 20, bottom: 8, containLabel: true },
    tooltip: { trigger: 'axis' },
    xAxis: {
      type: 'category',
      data: ratings.map((r) => r.label),
      axisTick: { show: false },
      axisLine: { lineStyle: { color: CHART_COLORS.grid } },
      axisLabel: { ...CHART_AXIS_LABEL_STYLE, interval: 0, formatter: formatRatingAxisLabel },
    },
    yAxis: {
      type: 'value',
      min: 0,
      max: 10,
      interval: 2,
      axisLabel: CHART_AXIS_LABEL_STYLE,
      splitLine: { lineStyle: { color: CHART_COLORS.grid } },
      axisLine: { show: false },
      axisTick: { show: false },
    },
    series: [
      {
        type: 'bar',
        data: ratings.map((r) => ({
          value: r.value,
          itemStyle: { color: r.color },
        })),
        barWidth: '55%',
        barMaxWidth: 36,
        label: {
          show: true,
          position: 'top',
          fontSize: 12,
          fontWeight: 500,
          fontFamily: CHART_FONT_FAMILY,
          color: CHART_COLORS.axisLabel,
        },
      },
    ],
  };
}
